export const shortWallet = (walletNumber: string) => walletNumber?.slice(0, 4) + "..." + walletNumber?.slice(-5);
